<template>
  <div>
    <v-breadcrumbs :items="breadcrumbs" divider="/" class="pa-0 mb-4">
      <template #item="{ item }">
        <v-breadcrumbs-item :to="item.to" :disabled="item.disabled" exact>
          {{ item.text }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>

    <div class="mb-6">
      <p class="text-2xl mb-1">
        Абонементы
      </p>
      <p class="text--secondary mb-0">
        Персональные предложения продления
      </p>
    </div>

    <v-tabs class="mb-5">
      <v-tab to="/abonements/offers" exact>
        Персональные предложения
      </v-tab>
    </v-tabs>

    <renewal-offers v-if="section === 'offers'" />
  </div>
</template>

<script>
import RenewalOffers from '@/views/abonements/RenewalOffers.vue'

export default {
  name: 'Abonements',
  components: { RenewalOffers },
  computed: {
    section() {
      return this.$route.params.section || 'offers'
    },
    breadcrumbs() {
      return [
        { text: 'Абонементы', to: '/abonements/offers', disabled: false },
        {
          text: 'Персональные предложения',
          to: '/abonements/offers',
          disabled: true,
        },
      ]
    },
  },
}
</script>
